// Module
var code = "<button class=\"odf-btn odf-btn-secondary odf-btn-block odf-space-outer-top-m odf-clickable goToMmbPage\" data-id=\"mytrips-mmb-btn\"> {{data.keys.mmbTxt}} </button> ";
// Exports
module.exports = code;